export type Agreement = {
    id: string;
    agreementTypeId: number;
    agreementTypeName: string;
    customerId: string;
    counterpartId: string;
    responsibleId: string;
    agreementNo: string;
    name: string;
    signer: string;
    area: string;
    category: string;
    description: string;
    created: string;
    createdBy: string;

    readers: string[];
    allReadersAccess: boolean;
    readOnly: boolean;
    status: AgreementStatus;
};

export type AgreementPeriodRenewals = {
    validFrom: string;
    commitmentPeriodTypeId: number;
    validTo: string;
    noticePeriod: number;
    noticePeriodTypeId: number;
    terminationDate: string;
    managedDate: string;
    sentForRenegotiateDate: string;

    periodAfterExtension: number;
    periodTypeIdAfterExtension?: number;
    expiryDateAfterTermination: string;
    noticePeriodAfterExtension: number;
    noticePeriodTypeIdAfterExtension: number;

    replacedByAgreementId?: string;
    replacedByAgreementName?: string;
    replacedAgreementId?: string;
    replacedAgreementName?: string;
};

export type AgreementReminder = {
    recipients: string[];
    reminderPeriod: number;
    periodTypeId: number;
    numOfReminders: number;
    escalatedRecipients: string[];
};

export type AgreementPayment = {
    paymentTerms: number;
    value: number;
    currency: string;
    invoiceIntervalId: number;
};

export type AgreementRealEstate = {
    propertyNo: string;
    apartmentNo: string;
    size: number;
    typeOfPremises: string;
};

export type AgreementRental = {
    employeeNo: string;
    employeeName: string;
    grossSalaryDeduction: number;
    benefitValue: number;
    additionalInsurance: boolean;
    registrationNo: string;
    carBrand: string;
    carModel: string;
    modelYear: number;
    mileageAnnual: number;
};

export type AgreementInventory = {
    inventoryNumber: string;
    typeOfInventory: string;
    condition: boolean;
    serialNumber: string;
    location: string;
    benefitValue: number;
    warranty: boolean;
    manufacturer: string;
    model: string;
    modelYear: number;
    user: string;
    purchaseCost: number;
};

export type AgreementList = {
    id: string;
    agreementTypeName: string;
    counterpartName: string;
    agreementNo: string;
    name: string;
    area: string;
    category: string;
    validFrom: string;
    validTo: string;
    responsible: string;
    customerName: string;
    counterpartResponsible: string;
    value: number;
    status: AgreementStatus;
    lastDayOfNotice: string;
    daysLeftToNotice: number;
    readOnly: boolean;
};

export enum AgreementStatus {
    Active = 0,
    Archived = 1,
    ReminderWarning = 2,
    Expired = 3,
    Managed = 4,
    OnGoing = 5
}
